require("!!/app/node_modules/script-loader/addScript.js")(require("!!/app/node_modules/raw-loader/index.js!/app/node_modules/bootstrap/dist/js/bootstrap.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/bootstrap/dist/js/bootstrap.js
// module id = 326
// module chunks = 2